// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Reservation-itemSection-EzC1N {
    background-color: var(--common-gray-bg-color);
    border: 1px solid var(--primary-border);
    border-radius: 12px;
    padding: 24px 30px 18px 30px;
    word-break: break-word;
}

.Reservation-displayFlex-DMrjf {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.Reservation-titleFlexStyle-KsmKl {
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}

.Reservation-avatarSpaceRight-gUuJi {
    margin-right: 19px;
}

.Reservation-displayGrid-aSSjv {
    display: grid;
    grid-template-columns: 1fr 1.2fr;
    gap: 25px;
}

.Reservation-moreItemGrid-z4ic_ {
    display: grid;
    grid-template-columns: 43.6% 32% 15%;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 25px;
}

.Reservation-baseLine-wFVSq {
    -webkit-box-align: baseline;
        -ms-flex-align: baseline;
            align-items: baseline;
}

.Reservation-iconSpace-Yf1e2 {
    margin-right: 4px;
    position: relative;
    top: 2px;
}

.Reservation-reservationStatusBtn-QLaZt,
.Reservation-reservationStatusBtn-QLaZt:hover,
.Reservation-reservationStatusBtn-QLaZt:active,
.Reservation-reservationStatusBtn-QLaZt:focus,
.Reservation-reservationStatusBtn-QLaZt:active:hover {
    border-radius: 19px;
    padding: 9px 15px;
    white-space: normal;
    display: inline-block;
}

.Reservation-errorMsg-jA52Y {
    margin: 0;
    padding-bottom: 6px;
}

.Reservation-tripDropDown-mcfOz {
    text-align: end;
}

.Reservation-noBackground-XrgZm {
    background: transparent !important;
}

.Reservation-claimDamageText-yyfSZ {
    list-style-type: none;
    cursor: pointer;
    margin-top: 2px;
}

.Reservation-displayInlineBlock-W3Qwr {
    display: inline-block;
}

.Reservation-claimBtn-L0K1u,
.Reservation-claimBtn-L0K1u:hover,
.Reservation-claimBtn-L0K1u:active,
.Reservation-claimBtn-L0K1u:focus {
    background-color: transparent !important;
    -webkit-box-shadow: unset !important;
            box-shadow: unset !important;
    border: unset !important;
    padding: 0 !important;
    color: var(--common-link-color) !important;
}

.Reservation-avatarSpaceLeft-Ng9DM {
    -webkit-box-flex: 1;
        -ms-flex: 1 1;
            flex: 1 1;
    -webkit-flex: 1;
}

@media screen and (max-width: 767px) {

    .Reservation-displayGrid-aSSjv {
        grid-template-columns: 1fr;
        gap: 15px;
    }

    .Reservation-itemSection-EzC1N {
        padding-inline: 20px;
    }

    .Reservation-profileAvatar-kYXiY {
        width: 70px;
        height: 70px;
    }

    .Reservation-tripDropDown-mcfOz {
        width: auto;
        text-align: start;
    }

    .Reservation-moreItemGrid-z4ic_ {
        grid-template-columns: 1fr 1fr;
        gap: 15px;
    }

    .Reservation-earningTextGroup-DmXup {
        text-align: end;
    }
}

@media screen and (max-width:480px) {
    .Reservation-moreItemGrid-z4ic_ {
        grid-template-columns: 100%;
    }

    .Reservation-earningTextGroup-DmXup {
        text-align: start;
    }
}

@media screen and (max-width:350px) {
    .Reservation-itemSection-EzC1N {
        padding-inline: 15px;
    }

    .Reservation-reservationStatusBtn-QLaZt,
    .Reservation-reservationStatusBtn-QLaZt:hover,
    .Reservation-reservationStatusBtn-QLaZt:active,
    .Reservation-reservationStatusBtn-QLaZt:focus,
    .Reservation-reservationStatusBtn-QLaZt:active:hover {
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Reservation/Reservation.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;IAC7C,uCAAuC;IACvC,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;AACjB;;AAEA;IACI,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,2BAAqB;QAArB,wBAAqB;YAArB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;;;;;IAKI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;;IAII,wCAAwC;IACxC,oCAA4B;YAA5B,4BAA4B;IAC5B,wBAAwB;IACxB,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,mBAAO;QAAP,aAAO;YAAP,SAAO;IACP,eAAe;AACnB;;AAEA;;IAEI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;;;;;QAKI,eAAe;IACnB;AACJ","sourcesContent":[".itemSection {\n    background-color: var(--common-gray-bg-color);\n    border: 1px solid var(--primary-border);\n    border-radius: 12px;\n    padding: 24px 30px 18px 30px;\n    word-break: break-word;\n}\n\n.displayFlex {\n    display: flex;\n}\n\n.titleFlexStyle {\n    align-items: center;\n    justify-content: space-between;\n}\n\n.avatarSpaceRight {\n    margin-right: 19px;\n}\n\n.displayGrid {\n    display: grid;\n    grid-template-columns: 1fr 1.2fr;\n    gap: 25px;\n}\n\n.moreItemGrid {\n    display: grid;\n    grid-template-columns: 43.6% 32% 15%;\n    align-items: center;\n    gap: 25px;\n}\n\n.baseLine {\n    align-items: baseline;\n}\n\n.iconSpace {\n    margin-right: 4px;\n    position: relative;\n    top: 2px;\n}\n\n.reservationStatusBtn,\n.reservationStatusBtn:hover,\n.reservationStatusBtn:active,\n.reservationStatusBtn:focus,\n.reservationStatusBtn:active:hover {\n    border-radius: 19px;\n    padding: 9px 15px;\n    white-space: normal;\n    display: inline-block;\n}\n\n.errorMsg {\n    margin: 0;\n    padding-bottom: 6px;\n}\n\n.tripDropDown {\n    text-align: end;\n}\n\n.noBackground {\n    background: transparent !important;\n}\n\n.claimDamageText {\n    list-style-type: none;\n    cursor: pointer;\n    margin-top: 2px;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.claimBtn,\n.claimBtn:hover,\n.claimBtn:active,\n.claimBtn:focus {\n    background-color: transparent !important;\n    box-shadow: unset !important;\n    border: unset !important;\n    padding: 0 !important;\n    color: var(--common-link-color) !important;\n}\n\n.avatarSpaceLeft {\n    flex: 1;\n    -webkit-flex: 1;\n}\n\n@media screen and (max-width: 767px) {\n\n    .displayGrid {\n        grid-template-columns: 1fr;\n        gap: 15px;\n    }\n\n    .itemSection {\n        padding-inline: 20px;\n    }\n\n    .profileAvatar {\n        width: 70px;\n        height: 70px;\n    }\n\n    .tripDropDown {\n        width: auto;\n        text-align: start;\n    }\n\n    .moreItemGrid {\n        grid-template-columns: 1fr 1fr;\n        gap: 15px;\n    }\n\n    .earningTextGroup {\n        text-align: end;\n    }\n}\n\n@media screen and (max-width:480px) {\n    .moreItemGrid {\n        grid-template-columns: 100%;\n    }\n\n    .earningTextGroup {\n        text-align: start;\n    }\n}\n\n@media screen and (max-width:350px) {\n    .itemSection {\n        padding-inline: 15px;\n    }\n\n    .reservationStatusBtn,\n    .reservationStatusBtn:hover,\n    .reservationStatusBtn:active,\n    .reservationStatusBtn:focus,\n    .reservationStatusBtn:active:hover {\n        font-size: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"itemSection": `Reservation-itemSection-EzC1N`,
	"displayFlex": `Reservation-displayFlex-DMrjf`,
	"titleFlexStyle": `Reservation-titleFlexStyle-KsmKl`,
	"avatarSpaceRight": `Reservation-avatarSpaceRight-gUuJi`,
	"displayGrid": `Reservation-displayGrid-aSSjv`,
	"moreItemGrid": `Reservation-moreItemGrid-z4ic_`,
	"baseLine": `Reservation-baseLine-wFVSq`,
	"iconSpace": `Reservation-iconSpace-Yf1e2`,
	"reservationStatusBtn": `Reservation-reservationStatusBtn-QLaZt`,
	"errorMsg": `Reservation-errorMsg-jA52Y`,
	"tripDropDown": `Reservation-tripDropDown-mcfOz`,
	"noBackground": `Reservation-noBackground-XrgZm`,
	"claimDamageText": `Reservation-claimDamageText-yyfSZ`,
	"displayInlineBlock": `Reservation-displayInlineBlock-W3Qwr`,
	"claimBtn": `Reservation-claimBtn-L0K1u`,
	"avatarSpaceLeft": `Reservation-avatarSpaceLeft-Ng9DM`,
	"profileAvatar": `Reservation-profileAvatar-kYXiY`,
	"earningTextGroup": `Reservation-earningTextGroup-DmXup`
};
module.exports = ___CSS_LOADER_EXPORT___;
